import React from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import {
  Typography,
  Box,
  Link,
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import AssetSearchBox from '../../components/search/AssetSearchBox';

type RouteParams = {
  symbol?: string;
};

const AssetLookup: React.FC = () => {
  const { symbol } = useParams<RouteParams>();

  if (!symbol) {
    return (
      <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/assets" underline="none" color="inherit">
            Assets
          </Link>
          <Typography color="text.primary">Lookup</Typography>
        </Breadcrumbs>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
            Asset Lookup
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Search for an asset by symbol to view details and update the image.
          </Typography>
        </Box>
        <AssetSearchBox />
      </Box>
    );
  }

  return null;
};

export default AssetLookup;
